import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/AllocationHistoryTableRow.styles'

export const AllocationHistoryRowSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
    </div>
  )
}
